module.exports = __webpack_public_path__ + "static/media/nu3.86a8aafc.webp";